import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Returns `{ canOverride(module) → bool, isAdmin, ready }` based on the current
 * user's per-module Numbering Override permissions. The result is cached for
 * the session — voucher forms can call this freely without flooding the API.
 */
let _cache = null;
let _inflight = null;

export function useNumberingOverride() {
  const [state, setState] = useState({
    ready: !!_cache,
    isAdmin: _cache?.is_admin || false,
    modules: _cache?.modules || {},
  });

  useEffect(() => {
    if (_cache) return;
    if (!_inflight) {
      _inflight = api.get("/numbering/my-override-permissions")
        .then(r => { _cache = r.data || { modules: {} }; return _cache; })
        .catch(() => { _cache = { modules: {} }; return _cache; })
        .finally(() => { _inflight = null; });
    }
    let alive = true;
    _inflight.then(c => alive && setState({
      ready: true, isAdmin: c.is_admin || false, modules: c.modules || {},
    }));
    return () => { alive = false; };
  }, []);

  return {
    ...state,
    canOverride: (module) => state.isAdmin || !!state.modules[module],
  };
}

/** Allow other code (e.g. logout flow) to invalidate the cache. */
export function resetNumberingOverrideCache() {
  _cache = null;
  _inflight = null;
}
